import React from 'react';
import { Rating, Typography } from 'fronton-react';
import {
  reviewContent,
  reviewContentBg,
  reviewContentContainer,
  reviewRating,
  reviewText,
} from './review-hint-styles';


export const REVIEWS_PER_PAGE = 5;

type TProps = {
  rating: number;
  text: string;
  store?: string;
  date: string;
};

export const ReviewHint: React.FC<TProps> = ({ rating, text, store, date }) => (
  <div className={reviewContentContainer} data-qa="review-content">
    <div className={reviewContentBg} />
    <div className={reviewContent}>
      <Rating className={reviewRating} value={rating} size="l" />
      <Typography
        className={reviewText}
        color="text-invert"
        variant="s"
        size="body_long"
      >
        {text}
      </Typography>
      <div>
        {store && (
          <Typography variant="caption" color="text-minor">
            {store}{','}{' '}
          </Typography>
        )}
        <Typography variant="caption" color="text-minor">
          {date}
        </Typography>
      </div>
    </div>
  </div>
);
